import { Type } from '@angular/core';
import { ActivatedRouteSnapshot, ActivatedRoute, UrlSegment, Params, Data, Route, ParamMap } from '@angular/router';
import { Observable, of } from 'rxjs';
import { IPagedResults, IUser, ICustomer} from './mock.interfaces';
import { Injectable } from '@angular/core';

//Below added by Nilan- was giving null pointer when this service was injected
@Injectable({
    providedIn: 'root'
})
export class ChartMockService {
    constructor() {}

    getPieChartLabelNDataMock(): Observable<IPagedResults<any>> { //<IPagedResults<any[]>> 
        console.log("inside mock getPieChartLabelNDataMock--");
        return of({
            totalRecords: 1,
            results: piChartLabelDataNew, //piChartLabelData
        });
    }

    getDoughnutChartLabelNDataMock(): Observable<IPagedResults<any>> { //<IPagedResults<any[]>> 
        console.log("*****inside mock getDoughnutChartLabelNDataMock--");
        return of({
            totalRecords: 1,
            results: doughnutChartLabelData
        });
    }
    getBarChartLabelNDataMock(): Observable<IPagedResults<any>> { //<IPagedResults<any[]>> 
        console.log("*****inside mock getBarChartLabelNDataMock--");
        return of({
            totalRecords: 1,
            results: barChartLabelDataNew 
        });
    }

    getLineChartLabelNDataMock(): Observable<IPagedResults<any>> { //<IPagedResults<any[]>> 
        console.log("*****inside mock getLineChartLabelNDataMock--");
        return of({
            totalRecords: 1,
            results: lineChartLabelDataNew, //lineChartLabelData, lineChartLabelDataNew
        });
    }
    getRadarChartLabelNDataMock(): Observable<IPagedResults<any>> { //<IPagedResults<any[]>> 
        console.log("*****inside mock getRadarChartLabelNDataMock--");
        return of({
            totalRecords: 1,
            results: radarChartLabelData
        });
    }
}
export const piChartLabelDataNew = {"pieChartLabels":[ 'Book Sales' ,  'Donation' , 'Uniform Sales', 'Miscellaneous'],
                                                "pieChartDatasets": [{data: [ 300, 500, 100, 120 ]}] }

export const piChartLabelData = {"pieChartLabelList":['Online', 'Offline', 'Busy'],"pieChartDataList":[2,2,2]}
export const doughnutChartLabelData = {"doughnutChartLabelList":['Consumedd', 'Remainingg'],"doughnutChartDataList":[{data: [100,150],}]}

export const barChartLabelData = {"barChartLabelList":['2020', '2021','2022', '2023'],
                                    "barChartDataList":[
                                        {data: [55, 60, 75, 80], label: 'Google'},
                                        {data: [45, 48, 70, 77], label: 'Facebook'},
                                        {data: [58, 55, 63, 73], label: 'Linkedin'}
                                    ]
                                 }
export const barChartLabelDataNew = {labels: [ '01', '02', '03', '04', '05', '06', '07','08', '09', '10', '11', '12', '13', '14','15', '16', '17', '18', '19', '20', '21', '22', '23', '24','25', '26', '27', '28', '29', '30', '31' ],
                                        datasets: [
                                            { data: [ 65, 44, 80, 81, 56, 55, 40,65, 59, 80, 81, 56, 55, 40,65, 59, 80, 81, 56, 55, 40, 56, 55, 40,65, 59, 80, 81, 56, 55, 40 ], label: 'Income' },
                                            { data: [ 28, 48, 40, 19, 86, 27, 90,28, 48, 40, 19, 86, 27, 90,28, 48, 40, 19, 86, 27, 90, 56, 55, 40,65, 59, 80, 81, 56, 55, 40 ], label: 'Expense' }
                                        ]
                                 }

export const lineChartLabelData = {"lineChartLabelList":['January', 'February', 'March', 'April'],
                                    "lineChartDataList":[
                                        { data: [85, 72, 78, 75, 77, 75], label: 'Crude oil prices' },
                                        { data: [80, 70, 72, 70, 73, 70], label: 'Petrol oil prices' },
                                        ]
                                  }
export const lineChartLabelDataNew =  { labels: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'June',
      'July',
      'Aug',
      'Sept',
      'Oct',
      'Nov',
      'Dec'
    ],
    datasets: [
      {
        data: [ 65, 59, 80, 81, 56, 55, 40,65, 59, 80, 81, 56 ],
        label: 'Income',
        fill: false,
        tension: 0.5,
        borderColor: 'green',
        backgroundColor: 'rgba(255,0,0,0.3)'
      },
      {
        data: [ 34, 29, 70, 51, 96, 25, 70,35, 79, 40, 31, 96 ],
        label: 'Expense',
        fill: false,
        tension: 0.5,
        borderColor: 'red',
        backgroundColor: 'rgba(255,0,0,0.3)'
      }

    ]
  }
export const radarChartLabelData = {"radarChartLabelList":['Punctuality', 'Communication', 'Problem Solving',
                                                'Team Player', 'Coding Skill', 'Technical Knowledge', 'Meeting Deadlines'],
                                    "radarChartDataList":[
                                        { data: [0, 1, 2, 3, 4, 5, 6], label: 'Employee Skill Analysis' }
                                        ]
                                    }